import React from 'react';
import ReactDOM from 'react-dom';
import config from 'src/config';
import { i18n, init as i18nInit } from 'src/i18n';
import { AuthPlan } from 'src/modules/auth/authPlan';
import AuthService from 'src/modules/auth/authService';
import './index.css';
import { AuthToken } from './modules/auth/authToken';
import { initImpactTracking } from 'src/modules/impact/impactTracking';
import { whenMarketing } from 'src/modules/consent/consent';

//
(async function () {
  whenMarketing(() => {
    if (config.pixelId) {
      try {
        // @ts-ignore
        window.fbq('init', '357164989128215');
        // @ts-ignore
        window.fbq('track', 'PageView');
      } catch (error) {
        console.error(error);
      }
    }

    initImpactTracking();
  });

  const isSocialOnboardRequested =
    AuthService.isSocialOnboardRequested();
  AuthPlan.applyFromLocationUrlIfExists();
  AuthToken.applyFromLocationUrlIfExists();
  if (isSocialOnboardRequested) {
    await AuthService.socialOnboard();
  }
  await i18nInit();

  const App = require('./App').default;
  document.title = i18n('app.title');
  ReactDOM.render(<App />, document.getElementById('root'));
})();
